import { render, staticRenderFns } from "./OrderEmailHistory.vue?vue&type=template&id=b9278fd2&scoped=true"
import script from "./OrderEmailHistory.vue?vue&type=script&lang=js"
export * from "./OrderEmailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9278fd2",
  null
  
)

export default component.exports